import styled from 'styled-components'
import {
  InvitePeopleField,
  InvitePeopleFieldInviteButton,
} from '@sketch/modules-common'

export const StyledInviteButton = styled(InvitePeopleFieldInviteButton)`
  width: 68px;
`

export const StyledInvitePeopleField = styled(InvitePeopleField)`
  margin-right: 16px;
  max-width: calc(100% - 85px);
`

export const MembersList = styled.div`
  margin-top: 16px;
`
